import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { LOGO_URL } from '../data/mock';
import { Menu, X } from 'lucide-react';

// Updated navigation links with proper routes
const HEADER_NAV_LINKS = [
  { name: 'Compare & Save', href: '/#compare' },
  { name: 'Products', href: '/#products' },
  { name: 'How It Works', href: '/#how-it-works' },
  { name: 'Battery Deal', href: '/battery-deal', isRoute: true, highlight: true },
  { name: 'Rebate Changes', href: '/rebate-changes', isRoute: true },
  { name: 'Blog', href: '/blog', isRoute: true },
  { name: 'About Us', href: '/about', isRoute: true },
];

export const Header = ({ onStartComparing }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img
              src={LOGO_URL}
              alt="CompareYourOptions.com.au"
              className="h-8 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {HEADER_NAV_LINKS.map((link) => (
              link.isRoute ? (
                <Link
                  key={link.name}
                  to={link.href}
                  data-testid={`nav-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  className={`font-medium text-sm transition-colors duration-200 ${
                    link.highlight
                      ? 'text-cyo-orange hover:text-cyo-orange-dark font-semibold inline-flex items-center gap-1'
                      : 'text-gray-600 hover:text-cyo-orange'
                  }`}
                >
                  {link.highlight && (
                    <span className="w-1.5 h-1.5 rounded-full bg-cyo-orange animate-pulse" />
                  )}
                  {link.name}
                </Link>
              ) : (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-gray-600 hover:text-cyo-orange font-medium text-sm transition-colors duration-200"
                >
                  {link.name}
                </a>
              )
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button
              onClick={onStartComparing}
              className="bg-cyo-orange hover:bg-cyo-orange-dark text-white font-medium px-5 py-1.5 h-9 text-sm rounded-lg shadow-sm hover:shadow-md transition-all duration-200"
            >
              Start Comparing
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-cyo-orange hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-3">
              {HEADER_NAV_LINKS.map((link) => (
                link.isRoute ? (
                  <Link
                    key={link.name}
                    to={link.href}
                    data-testid={`mobile-nav-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className={`font-medium py-2 transition-colors ${
                      link.highlight
                        ? 'text-cyo-orange font-semibold inline-flex items-center gap-2'
                        : 'text-gray-600 hover:text-cyo-orange'
                    }`}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {link.highlight && (
                      <span className="w-1.5 h-1.5 rounded-full bg-cyo-orange animate-pulse" />
                    )}
                    {link.name}
                  </Link>
                ) : (
                  <a
                    key={link.name}
                    href={link.href}
                    className="text-gray-600 hover:text-cyo-orange font-medium py-2 transition-colors"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {link.name}
                  </a>
                )
              ))}
              <Button
                onClick={() => {
                  onStartComparing();
                  setMobileMenuOpen(false);
                }}
                className="bg-cyo-orange hover:bg-cyo-orange-dark text-white font-semibold mt-2"
              >
                Start Comparing
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
